import { Separator } from "@/components/ui/separator";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { AppBreadcrumb } from "@/components/AppBreadcrumb";
import ServiceRequestAlert from "components/control/dashboard/ServiceRequestAlert";

const Header: React.FC = () => {
  // LAYOUT PROTOTYPE: h-14 + border-b (was h-16, borderless) — a shorter,
  // defined header like the shadcn dashboard reference. mb-4 kept so every
  // page keeps its top breathing room below the border.
  return (
    <header className="flex h-14 mb-4 items-center gap-2 border-b border-border transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-12">
      <div className="flex items-center gap-2 px-4 w-full">
        <SidebarTrigger />
        <Separator
          orientation="vertical"
          className="mr-2 data-[orientation=vertical]:h-4 mt-2 bg-primary"
        />
        <AppBreadcrumb />
        <div className="flex items-center gap-x-4 sm:gap-x-6 ml-auto mr-2">
          <ServiceRequestAlert />
        </div>
      </div>
    </header>
  );
};

export default Header;
